import AbstractModel from '../AbstractModel';

class RoomModel extends AbstractModel {}

export default RoomModel;
